import { useNavigate, useParams, useLocation } from 'react-router-dom';

export interface AdditionalWorkflowLaunchNavigator {
  isAiFlow: boolean;
  openVerifyDataPage: () => void;
  openGroupsPage: () => void;
  openConflictsPage: () => void;
  openKeyDateTasksPage: () => void;
  openAllTasksPage: () => void;
  openPartiesPage: () => void;
  openProjectPage: (afterLaunch?: boolean) => void;
  openFirstStep: (hasGroups: boolean) => void;
}

export default function useAdditionalWorkflowLaunchNavigator(): AdditionalWorkflowLaunchNavigator {
  const navigator = useNavigate();
  const params = useParams();
  const location = useLocation();

  const projectId = params.id!;
  const planId = params.planId!;
  const isAiFlow = location.pathname.includes('/ailaunch/');
  const routePrefix = isAiFlow ? 'ailaunch' : 'launch';
  const basePath = `/transactions/${projectId}/plans/${planId}/${routePrefix}`;

  const openVerifyDataPage = () => {
    navigator(`${basePath}/verifydata`);
  };

  const openGroupsPage = () => {
    navigator(`${basePath}/groups`);
  };

  const openConflictsPage = () => {
    navigator(`${basePath}/conflicts`);
  };

  const openKeyDateTasksPage = () => {
    navigator(`${basePath}/keydates`);
  };

  const openAllTasksPage = () => {
    navigator(`${basePath}/alltasks`);
  };

  const openPartiesPage = () => {
    navigator(`${basePath}/parties`);
  };

  const openProjectPage = (afterLaunch?: boolean) => {
    let uri = `/transactions/${projectId}`;
    if (afterLaunch) {
      uri += '?afterLaunch=1';
    }
    navigator(uri);
  };

  const openFirstStep = (hasGroups: boolean) => {
    if (hasGroups) {
      openGroupsPage();
    } else {
      openKeyDateTasksPage();
    }
  };

  return {
    isAiFlow,
    openVerifyDataPage,
    openGroupsPage,
    openConflictsPage,
    openKeyDateTasksPage,
    openAllTasksPage,
    openPartiesPage,
    openProjectPage,
    openFirstStep,
  };
}
